<template>
    <div id="Visit_Reassign">
        <HomeCareReassign
            v-if="options.Application == applicationEnum.HomeCare"
            :visit-details="options"
            :preSelectedEmpId="preSelectedEmpId"
            v-model:isSaving="isSaving"
            :reassign="reassignVisit"
            :cancel="cancel"
            :ok="ok"
        />
        <ProductReassign
            v-if="
                options.Application == applicationEnum.AgencyCore ||
                options.Application == applicationEnum.AxxessHospiceFE ||
                options.Application == applicationEnum.AxxessPalliative
            "
            :visit-details="options"
            :preSelectedEmpId="preSelectedEmpId"
            :is-loading="isLoading"
            :is-saving="isSaving"
            :employee-list="employeeList"
            :reassign="reassignVisit"
            :cancel="cancel"
        />
    </div>
</template>

<script lang="ts" src="./ReassignVisit"></script>
<style lang="scss" src="../ScheduleVisit/ScheduleVisit.scss"></style>
